module.exports = __webpack_public_path__ + "static/img/consumer-h5-2.d74f5ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/consumer-h5-2.png
// module id = S8AR
// module chunks = 34